import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { webApi } from 'src/app/api';
import { AppService } from 'src/app/app.service';
import { ActiveDeleteDialogComponent } from '../../special-offers/active-delete-dialog/active-delete-dialog.component';

export interface Employee {
  _id: string;
  createdAt: Date;
  isActive: boolean;
  fullName: string;
  accessControlList: any;
  mobileNo: string;
  email: string;
}
@Component({
  selector: 'app-list-employee',
  templateUrl: './list-employee.component.html',
  styleUrls: ['./list-employee.component.scss'],
})
export class ListEmployeeComponent implements OnInit {
  isLoading: boolean = false;
  userDetails: any;
  httpHeaders: any;
  magazineDetails: any;

  constructor(
    public as: AppService,
    private matDialog: MatDialog,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('TGV2WebAdminDetails')!);
    this.httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.userDetails['accessToken']}`,
    });
    this.fetchEmployee();
  }

  isAddEditCalled: boolean = false;
  dataToEdit: any;
  p: any = 1;
  count: any = 50;

  opened: boolean = false;
  modeNum: number = 0;
  positionNum: number = 0;
  dock: boolean = false;
  closeOnClickOutside: boolean = false;
  closeOnClickBackdrop: boolean = true;
  showBackdrop: boolean = false;
  animate: boolean = true;
  trapFocus: boolean = true;
  autoFocus: boolean = true;
  keyClose: boolean = false;
  toggleSortDiv: boolean = false;
  downloadReport: boolean = false;

  listOfEmployeeToDisplay: Array<Employee> = [];
  listOfEmployee: Array<Employee> = [];
  listOfEmployeeOriginal: any = [];
  listOfProduct: any = [];
  listOfCategory: any = [];

  myHeaders = new Headers();

  async fetchEmployee() {
    this.isLoading = true;
    this.listOfEmployeeToDisplay = [];
    try {
      let URL = '';

      URL = `${webApi.domain + webApi.endPoint.fetchAllAdmins}`;

      await this.as
        .fetchDetailViaGet(URL, this.httpHeaders)
        .then((data: any) => {
          if (data['success']) {
            this.listOfEmployeeToDisplay = data['result'];
            this.listOfEmployee = [...this.listOfEmployeeToDisplay];
            this.isLoading = false;
          } else {
            this.listOfEmployeeToDisplay = [];
            this.listOfEmployee = [];
            this.isLoading = false;
          }
        });
    } catch (error) {
      this.listOfEmployeeToDisplay = [];
      this.listOfEmployee = [];
      this.isLoading = false;
    }
  }

  searchData(target: any) {
    console.log(target.value);
    let serachQuery = target.value;
    if (serachQuery != '') {
      let tempSearchList: any = [];
      this.listOfEmployeeToDisplay = [];
      this.listOfEmployee.forEach((employee: any, index: number) => {
        if (
          String(employee.language)
            .toLowerCase()
            .includes(String(serachQuery).toLowerCase()) ||
          String(employee.categoryId.name)
            .toLowerCase()
            .includes(String(serachQuery).toLowerCase())
        ) {
          tempSearchList.push(employee);
        }
      });
      this.listOfEmployeeToDisplay = tempSearchList;
    } else {
      this.listOfEmployeeToDisplay = [];
      this.listOfEmployeeToDisplay = this.listOfEmployee;
    }
  }

  updateActiveStatus(employee: Employee, isActive: boolean) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { employee: employee, source: 'Active Employee' };

    let dialogRef = this.matDialog.open(
      ActiveDeleteDialogComponent,
      dialogConfig
    );
    dialogRef.updatePosition(dialogConfig.position);
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
      }
    });
    dialogRef.componentInstance.closeActivityAtDialog.subscribe(async (res) => {
      if (res == null) {
        return;
      } else {
        const param = {
          employeeId: res['value']['_id'],
          action: 'Status',
          isActive: isActive,
        };

        const URL = `${
          webApi.domain + webApi.endPoint.updateActiveOrDeleteStatusAdmin
        }`;
        await this.as
          .updateDataViaPut(param, URL, this.httpHeaders)
          .then((data: any) => {
            if (data['success']) {
              this.listOfEmployeeToDisplay.forEach(
                (employee: any, index: number) => {
                  if (employee['_id'] == res['value']['_id']) {
                    employee.isActive = isActive;
                  }
                }
              );
              this.listOfEmployee = [...this.listOfEmployeeToDisplay];
              if (isActive) {
                this.showSuccessToaster(
                  'Employee Activated Successfully',
                  'Success'
                );
              } else {
                this.showSuccessToaster(
                  'Employee Inactivated Successfully',
                  'Success'
                );
              }
            } else {
              this.showErrorToaster(
                'Error Occurred while updating employee. Try again',
                'Error'
              );
            }
          });
      }
    });
  }

  deleteEmployee(employee: Employee) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { employee: employee, source: 'Delete Employee' };

    let dialogRef = this.matDialog.open(
      ActiveDeleteDialogComponent,
      dialogConfig
    );
    dialogRef.updatePosition(dialogConfig.position);
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
      }
    });
    dialogRef.componentInstance.closeActivityAtDialog.subscribe(async (res) => {
      if (res == null) {
        return;
      } else {
        const param = {
          employeeId: res['value']['_id'],
          action: 'Delete',
        };

        const URL = `${
          webApi.domain + webApi.endPoint.updateActiveOrDeleteStatusAdmin
        }`;
        await this.as
          .updateDataViaPut(param, URL, this.httpHeaders)
          .then((data: any) => {
            if (data['success']) {
              let index = 0;
              this.listOfEmployeeToDisplay.forEach(
                (employee: any, i: number) => {
                  if (employee['_id'] == res['value']['_id']) {
                    index = i;
                  }
                }
              );
              this.listOfEmployeeToDisplay.splice(index, 1);
              this.listOfEmployee = [...this.listOfEmployeeToDisplay];

              this.showSuccessToaster(
                'Employee Deleted Successfully',
                'Success'
              );
            } else {
              this.showErrorToaster(
                'Error Occurred while deleting employee. Try again',
                'Error'
              );
            }
          });
      }
    });
  }

  addNewEmployee() {
    this.toggleOpened();
  }

  editEmployee(magazine: any) {
    let magazineToEdit;
    this.listOfEmployeeToDisplay.forEach((mgz: any) => {
      if (mgz['_id'] == magazine._id) {
        magazineToEdit = mgz;
      }
    });
    this.dataToEdit = magazineToEdit;
    this.toggleOpened();
  }

  showSuccessToaster(message: string | undefined, title: string | undefined) {
    this.toastr.success(message, title);
  }
  showErrorToaster(message: string | undefined, title: string | undefined) {
    this.toastr.error(message, title);
  }

  toggleOpened(): void {
    this.isAddEditCalled = true;
    this.opened = !this.opened;
  }
  toggleClose(event: any): void {
    this.opened = !this.opened;
    this.isAddEditCalled = false;
    this.isLoading = true;
    if (event != null) {
      if (event == 'Error') {
        if (this.dataToEdit != null) {
          this.showErrorToaster(
            'Error while editing employee details.Kindly try again',
            'Error'
          );
        } else {
          this.showErrorToaster(
            'Error while adding employee details.Kindly try again',
            'Error'
          );
        }
        this.dataToEdit = null;
        this.isLoading = false;
        return;
      } else {
        const index = this.listOfEmployeeToDisplay.findIndex(
          (employee: any) => employee['_id'] == event['_id']
        );

        if (index == -1) {
          this.listOfEmployeeToDisplay.push(event);
          this.listOfEmployee = [...this.listOfEmployeeToDisplay];
          this.showSuccessToaster('Employee added successfully', 'Success');
        } else {
          this.listOfEmployeeToDisplay[index] = event;
          this.listOfEmployee = [...this.listOfEmployeeToDisplay];
          this.showSuccessToaster('Employee Updated successfully', 'Success');
        }
        this.dataToEdit = null;
        this.isLoading = false;
        return;
      }
    }

    this.dataToEdit = null;
    this.isLoading = false;
  }

  onBackdropClicked(): void {
    console.info('Backdrop clicked');
  }
}
